export default __webpack_public_path__ + "static/media/img5.642a9893.jpg";